const Color = color => {
  switch (color) {
    case 'white-blue':
      return `
        color: #222;
        border-color: #FFF;
        background-color: #FFF;
        
        &:hover {
          color: #222;
          border-color: #61DAFB;
          background-color: #61DAFB;
        }
        &:active {
          color: #61DAFB;
          border-color: #282C34;
          background-color: #282C34;
        }`;
    
    case 'white-red':
      return `
        color: #222;
        border-color: #FFF;
        background-color: #FFF;
        
        &:hover {
          color: #222;
          border-color: #F0564D;
          background-color: #F0564D;
        }
        &:active {
          color: #FFF;
          border-color: #EE4035;
          background-color: #EE4035;
        }`;

    case 'gray-red':
      return `
        color: #000;
        border-color: #EAEAEA;
        background-color: #EAEAEA;

        &:hover {
          color: #FFF;
          border-color: #F0564D;
          background-color: #F0564D;
        }
        &:active {
          color: #FFF;
          border-color: #EE4035;
          background-color: #EE4035;
        }`;

    case 'yellow':
      return `
        color: #FFF;
        border-color: #EEA236;
        background-color: #F5B03D;
        
        &:hover {
          border-color: #DE7E0F;
          background-color: #F39C0D;
        }
        &:active {
          border-color: #DE7E0F;
          background-color: #DE7E0F;
        }`;

    case 'red':
      return `
        color: #FFF;
        border-color: #EE4035;
        background-color: #EE4035;

        &:hover {
          border-color: #DD1F13;
          background-color: #DD1F13;
        }
        &:active {
          border-color: #D41222;
          background-color: #D41222;
        }`;

    case 'green':
      return `
        color: #FFF;
        border-color: #6DC066;
        background-color: #6DC066;

        &:hover {
          border-color: #4FAC47;
          background-color: #4FAC47;
        }
        &:active {
          border-color: #3E8838;
          background-color: #3E8838;
        }`;
      
      case 'dark-yellow':
        return`
          color: #222;
          border-color: #FFFF02;
          background-color: #FFFF02;
          
          &:hover {
            border-color: #F3F325;
            background-color: #F3F325;
          }
          &:active {
            border-color: #F3F325;
            background-color: #F3F325;
          }`;
      
      case 'orange':
        return`
          color: #FFF;
          border-color: #eea236;
          background-color: #eea236;
          
          &:hover {
            border-color: #ec971f;
            background-color: #ec971f;
          }
          &:active {
            border-color: #ec971f;
            background-color: #ec971f;
          }`;

    case 'download':
      return `
        color: #FFF;
        border-color: #00542A;
        background-color: #008744;

        &:hover {
          background-color: #006E37;
        }
        &:active {
          background-color: #00542A;
        }`;

    case 'disabled':
      return `
        color: #D1D1D1;
        border-color: #DFDFDF;
        background-color: #F7F7F7;
        &:hover {
          color: #D1D1D1;
          border-color: #DFDFDF;
          background-color: #F7F7F7;
        }
        &:active {
          color: #d1d1d1;
          border-color: #dfdfdf;
          background-color: #f7f7f7;
        }`;

    default:
      return `
        color: #000;
        border: 0;
        background-color: #61DAFB;
        transition: all 0.2s ease-out;
        &:hover {
          color: #FFF;
          background-color: #373940;
        }
        &:active {
          color: #61DAFB;
          background-color: #282C34;
        }`;
  }
}

export default Color;


// WEBPACK FOOTER //
// ./client/components/Styled/Button/Color.js